//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import icons from '~/assets/img/icons';
import FaqThemesDetails from "./FaqThemesDetails";
import ResponsiveImage from "../../common/ResponsiveImage";
import breakpointsListMixin from '~/mixins/breakpointsList.mixin';

export default {
    name: "FaqThemesAccordion",
    scrollToTop: false,
    components: {ResponsiveImage, FaqThemesDetails},
    props: {
        items: {
            type: Array,
            default: () => ([])
        },
        value: {
            type: String,
            default: ''
        }
    },
    mixins: [
        breakpointsListMixin,
    ],
    data() {
        return {
            icons
        }
    },
    methods: {
        onSelect(id) {
            if (this.tabletLandscapeUp || this.value !== id) {
                this.$emit('input', id);
            } else {
                this.$emit('input', null);
            }
        },
        beforeOpenItem(el) {
            el.style.height = `0`;
            el.clientHeight;
            setTimeout(() => {
                el.style.height = `${el.children[0].scrollHeight}px`;
            });
        },
        afterOpenItem(el) {
            el.style.height = "auto";
        },
        beforeCloseItem(el) {
            setTimeout(() => {
                el.style.height = `${el.scrollHeight}px`;
                el.clientHeight;
                el.style.height = "0";
            })
        }
    }
}
